import { render, staticRenderFns } from "./BaseHeading.vue?vue&type=template&id=b5af294a&functional=true&"
import script from "./BaseHeading.vue?vue&type=script&lang=ts&"
export * from "./BaseHeading.vue?vue&type=script&lang=ts&"
import style0 from "./BaseHeading.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  true,
  null,
  null,
  null
  
)

export default component.exports